import { render, staticRenderFns } from "./OfficialsTable.vue?vue&type=template&id=615df273&"
import script from "./OfficialsTable.vue?vue&type=script&lang=js&"
export * from "./OfficialsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports